import React, { useEffect } from 'react';
import EnrollmentCardsSection from 'components/common/enrollment/EnrollmentCardsSection';
import { useZywaveGroupInfoPageStore } from 'store/pages/group/zywave-group-info/zywaveGroupInfoPageStore';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { GroupDetailStyled, GroupInfoStyled, TitleStyled, ValueStyled, SectionTitleStyled } from './styles';
import ZywaveQuoteCard from './ZywaveQuoteCard';

const ZywaveGroupProfile: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();

  const {
    isLoading,
    activeNewSaleEnrollmentPeriods,
    quotingEnrollmentPeriods,
    groupName,
    groupAORNpn,
    getInitialData,
  } = useZywaveGroupInfoPageStore();

  useEffect(() => {
    if (groupId) {
      void getInitialData(groupId);
    } else {
      throw new Error('Group id is missing');
    }
  }, []);

  return (
    <NoSidebarPageLayout
      pageHeader={{
        title: 'Group Dashboard',
        spacing: { top: 'm', bottom: 's' },
        backButtonText: 'Back to CPQ',
        onBackButtonClick: () => {
          window.location.href = 'https://proposals.zywave.com/';
        },
      }}
      isInitialLoading={isLoading}
    >
      <GroupInfoStyled>
        <GroupDetailStyled>
          <TitleStyled>Group Name:</TitleStyled>
          <ValueStyled>{groupName}</ValueStyled>
        </GroupDetailStyled>
        <GroupDetailStyled>
          <TitleStyled>Agent of Record NPN:</TitleStyled>
          <ValueStyled>{groupAORNpn}</ValueStyled>
        </GroupDetailStyled>
      </GroupInfoStyled>

      {activeNewSaleEnrollmentPeriods.length > 0 && (
        <EnrollmentCardsSection
          cardsList={activeNewSaleEnrollmentPeriods}
          sectionTitle="Current enrollments"
          type="ee"
        />
      )}

      {quotingEnrollmentPeriods.length > 0 && (
        <section>
          <SectionTitleStyled>Quotes</SectionTitleStyled>
          {quotingEnrollmentPeriods.map((enrollmentPeriod) =>
            enrollmentPeriod.proposals.map((proposal) => (
              <ZywaveQuoteCard
                key={proposal.cartId}
                groupId={groupId}
                periodId={enrollmentPeriod.id}
                effectiveDate={enrollmentPeriod.effectiveDate}
                stage={enrollmentPeriod.stage}
                proposal={proposal}
              />
            )),
          )}
        </section>
      )}
    </NoSidebarPageLayout>
  );
});

export default ZywaveGroupProfile;
